import { render } from "./buy-again.vue?vue&type=template&id=4cc82eb0&scoped=true"
import script from "./buy-again.vue?vue&type=script&lang=js"
export * from "./buy-again.vue?vue&type=script&lang=js"

import "./buy-again.vue?vue&type=style&index=0&id=4cc82eb0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc82eb0"]])

export default __exports__